
export default[
    {
        path: "/",
        component: () => import('@/pages/Login/AuthLayout'),
        children: [
            {
                path: "login",
                name: "login",
                component: () => import('@/pages/Login/Login'),
            }
        ]
    }
]
